import styled, { css, keyframes } from 'styled-components';

const spin = keyframes`
	to { transform: rotate(360deg); }
`;

export const Base = styled.div`
	display: flex;
	align-items: center;
`;

// borderless mic treatment; sized to line up with the 30px IconButton row.
// Vertical nudge comes in via inline transform so the optical offset against
// the submit arrow can be tuned per variant.
export const MicButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	padding: 0;
	border: none;
	border-radius: 4px;
	background: transparent;

	&:hover {
		background-color: ${({ theme }) => theme.gray[200]};
		box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
	}
`;

export const Timer = styled.span`
	margin-left: 6px;
	font-size: 12px;
	font-weight: 500;
	font-variant-numeric: tabular-nums;
	color: ${({ theme }) => theme.gray[800]};
`;

export const Spinner = styled.div`
	width: 12px;
	height: 12px;
	border-radius: 50%;
	border: 2px solid ${({ theme }) => theme.gray[400]};
	border-top-color: ${({ theme }) => theme.gray[800]};
	animation: ${spin} 0.8s linear infinite;
	flex-shrink: 0;
	margin-left: 6px;
`;

export const ErrorPill = styled.div`
	display: flex;
	align-items: center;
	height: 24px;
	padding: 0 10px;
	border-radius: 999px;
	background-color: ${({ theme }) => theme.red[200]};
	font-size: 11px;
	font-weight: 500;
	color: ${({ theme }) => theme.red[700]};
	white-space: nowrap;
`;

// takeover treatment: covers the prompt box exactly, wearing that surface's own
// focused-input look — contents vanish, controls appear, the border lights up
export const TakeoverOverlay = styled.div<{ isCreator?: boolean }>`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 2;
	display: flex;
	align-items: flex-end;
	background-color: ${({ theme }) => theme.gray[100]};
	border: 1px solid ${({ theme }) => theme.gray[400]};

	${({ isCreator, theme }) =>
		isCreator
			? css`
					border-radius: 10px;
					padding: 0 16px 12px 16px;
					box-shadow: 0 0 0 3px ${`${theme.blue[300]}40`}, 0 2px 8px rgba(0, 0, 0, 0.06);
			  `
			: css`
					border-radius: 4px;
					padding: 0 4px 4px 4px;
			  `}
`;

export const Row = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	width: 100%;
`;

export const TakeoverLabel = styled.span`
	font-size: 13px;
	color: ${({ theme }) => theme.gray[800]};
	white-space: nowrap;
`;

export const Waveform = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 3px;
	height: 24px;
	flex: 1;
	min-width: 0;
	overflow: hidden;
`;

// height set inline: it tracks live mic level at animation rate, and inline
// style avoids a styled-components class per frame
export const LevelBar = styled.div`
	width: 3px;
	border-radius: 2px;
	background-color: ${({ theme }) => theme.gray[700]};
	flex-shrink: 0;
	transition: height 80ms linear;
`;

export const Spacer = styled.div`
	flex: 1;
`;

// replicates the submit button's optical-centering wrapper so the ✓ lands at
// the exact resting position of the arrow
export const SubmitMirrorWrapper = styled.div`
	padding-top: 4px;
	flex-shrink: 0;
`;
